<template>
  <tml-new-popup
    name="quote-popup"
    no-scroll-content
    :fill="false"
    layout="standard"
    size="normal"
  >
    <template #content>
      <tml-image alt="screen printing" :src="screenPrintImage" class="mb-2" />
      <h3>{{ productName }} from £{{ unitPrice }} per item</h3>
      <p>
        {{ quantity }} products made from premium quality organic cotton. Plus
        custom printing by our experienced professionals in a renewable energy
        powered factory. Fast, personal service.
      </p>
    </template>
    <template #footer>
      <tml-item-tray>
        <template #primary>
          <tml-button primary fill text="Learn more" href="/blog/" />
        </template>
        <template #secondary>
          <tml-button
            fill
            text="Call on 01983 409790"
            :href="mobileView ? 'tel:01983 409790' : '/contact/'"
          />
        </template>
      </tml-item-tray>
    </template>
  </tml-new-popup>
</template>

<script>
import {viewportSize} from '@teemill/common/helpers';
import screenPrintImage from '../assets/img/screen-print.jpg';

export default {
  name: 'QuotePopup',
  props: {
    productName: {
      type: String,
    },

    unitPrice: {
      type: Number,
    },

    quantity: {
      type: Number,
    },
  },
  data() {
    return {
      screenPrintImage,
    };
  },

  computed: {
    mobileView() {
      return viewportSize.isSmaller('md');
    },
  },
};
</script>
